import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { StudyIssuanceRequestHistory } from '../../../../shared/api/hscan/hospital';
import { useRequestedImageHistory } from '../../../../shared/hooks/hospitalHook';
import {
  HistoryTableModal,
  HistoryTableRow,
} from '../../common/components/HistoryTableModal';

interface RequestedStudyHistoryModalProps {
  id: string;
  open: boolean;
  onClose: (open: boolean) => void;
}
export const RequestedImageHistoryModal = (
  props: RequestedStudyHistoryModalProps,
) => {
  const { t } = useTranslation('translation', { keyPrefix: 'history' });
  const { id, open, onClose } = props;

  const makeContent = useCallback(
    (row: StudyIssuanceRequestHistory): HistoryTableRow => {
      let content = '';
      switch (row.status) {
        case 'PENDING': {
          content = `${t('studiesRequest.pending', {
            hospitalName: row.hospitalName ?? t('unknown'),
          })}`;
          break;
        }
        case 'DECLINED': {
          content = `${t('studiesRequest.declined', {
            comment: row.comment ?? t('unknown'),
          })}`;
          break;
        }
        case 'COMPLETED': {
          content = `${t('studiesRequest.completed')}`;
          break;
        }
        case 'FAILED': {
          content = `${t('studiesRequest.failed')}`;
          break;
        }
        case 'CANCELLED': {
          content = `${t('studiesRequest.cancelled')}`;
          break;
        }
      }
      return {
        createdAt: row.createdAt,
        content,
      };
    },
    [t],
  );

  const { data } = useRequestedImageHistory(id);
  const histories = useMemo(
    () => data?.map(row => makeContent(row)) ?? [],
    [data, makeContent],
  );

  return <HistoryTableModal open={open} onClose={onClose} rows={histories} />;
};
